import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import socials from '../../../utils/socials';

const Socials = ({ className }) => (
  <>
    {socials.map(({ name, image, href }) => (
      <a
        className={className}
        key={name}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        <img src={image} alt={name} />
      </a>
    ))}
  </>
);

Socials.propTypes = { className: PropTypes.string.isRequired };

export default styled(Socials)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 1.25rem;
  background: white;
  border-radius: 50%;

  img {
    width: 22px;
    height: 22px;
  }
`;
